module.exports = __webpack_public_path__ + "img/product1.9cd9a010.png";